const welcomeModalCopy = {
  header: 'Are you a health care professional?',
  primaryCta: 'Yes, I am',
  secondaryCta: 'No, I am not',
  secondaryCtaHref: 'https://www.welireg.com',
  body: 'The information on this site is intended for health care professionals in the United States, its territories, and Puerto Rico, and is not intended for the general public.',
};

export default welcomeModalCopy;